// src/components/UI/QuestionCard.js
import React, { useState, useRef, useEffect } from 'react';

const SWIPE_THRESHOLD = 50; // how many pixels you have to move to count as a swipe

const QuestionCard = ({ question, answer, detail, source }) => {
  const [flipped, setFlipped] = useState(false);
  const [touchStartX, setTouchStartX] = useState(null);
  const cardInnerRef = useRef(null);
  const frontRef = useRef(null);
  const backRef = useRef(null);

  const toggleFlip = () => setFlipped(prev => !prev);

  // Touch handlers
  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    if (touchStartX === null) return;
    const touchEndX = e.changedTouches[0].clientX;
    const dx = touchStartX - touchEndX;

    if (dx > SWIPE_THRESHOLD && !flipped) {
      // swiped left → open
      setFlipped(true);
    } else if (dx < -SWIPE_THRESHOLD && flipped) {
      // swiped right → close
      setFlipped(false);
    }

    setTouchStartX(null);
  };

  // Set initial height on mount
  useEffect(() => {
    if (frontRef.current && cardInnerRef.current) {
      cardInnerRef.current.style.height = `${frontRef.current.offsetHeight}px`;
    }
  }, []);

  // Update height & Masonry on flip
  useEffect(() => {
    const frontH = frontRef.current ? frontRef.current.offsetHeight : 0;
    const backH = backRef.current ? backRef.current.offsetHeight : 0;
    const newH = flipped ? backH : frontH;
    if (cardInnerRef.current) {
      cardInnerRef.current.style.height = `${newH}px`;
    }
    if (window.msnry?.layout) window.msnry.layout();
  }, [flipped]);

  return (
    <div
      className={`qa-grid__item qa-flip-card ${flipped ? 'is-active' : ''}`}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <div className="qa-flip-card__inner" ref={cardInnerRef}>
        {/* FRONT */}
        <div className="qa-flip-card__face qa-flip-card__face--front" ref={frontRef}>
          <div className="card question center-xs">
            <div className="qa-flip-card__content">
              <div className="badge-question large">
                <div className="badge-question-number large">Q</div>
              </div>
              <h4>{question}</h4>
              <button className="text-link view-answer" onClick={toggleFlip}>
                View Answer
              </button>
            </div>
          </div>
        </div>

        {/* BACK */}
        <div className="qa-flip-card__face qa-flip-card__face--back" ref={backRef}>
          <div className="badge-question small">
            <div className="badge-question-number small">Q</div>
          </div>
          <h5 className="margin-top-m">{question}</h5>
          {detail && <p>{detail}</p>}
          <div className="divider dotted" />
          <div className="badge-question small">
            <div className="badge-question-number small">A</div>
          </div>
          <p>{answer}</p>
          {source && (
            <div className="source-label">
              <img src="/images/i_Info.svg" alt="Info icon" />
              <p>{source}</p>
            </div>
          )}
          <button className="text-link close" onClick={toggleFlip}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuestionCard;
